<script setup lang="ts">
interface IProps {
    desktopOnly?: boolean;
    nightCountHelper?: boolean;
    nights?: string;
    divide?: boolean;
}
defineProps<IProps>();
</script>

<template>
    <div class="helpers" :class="{ 'desktop-only': desktopOnly }">
        <div class="help-orange">روزهای تعطیل</div>
        <mr-divider
            v-if="divide"
            class="info-divider"
            vertical
            :thickness="2"
        />
        <div v-show="nightCountHelper" class="help-info">
            {{ nights }}
        </div>
    </div>
</template>

<style lang="scss" scoped>
.info-divider {
    height: 20px;
    padding-inline: 8px;
}
.helpers {
    @include mobile-only {
        display: flex;
        align-items: center;
        @include f-gap(4px);
        flex-grow: 1;
        background-color: white;
        justify-content: center;
        padding-bottom: 8px;
        &.desktop-only {
            display: none;
        }
        .help-green {
            padding: 4px;
            border-radius: 4px;
            background-color: usePalette($p-green, $p-200);
            @include tg-s($w7, usePalette($p-green, $p-700));
        }
        .help-orange {
            display: flex;
            align-items: center;
            @include tg-xs($w7, usePalette($p-red, $p-500));
            &::before {
                content: '  ';
                width: 5px;
                height: 5px;
                border-radius: 100%;
                margin-left: 4px;
                background-color: usePalette($p-red, $p-500);
            }
        }
        .help-info {
            // text
            @include tg-s;
        }
    }
    display: flex;
    align-items: center;
    @include f-gap(10px);
    .help-green {
        padding: 4px;
        border-radius: 4px;
        background-color: usePalette($p-green, $p-200);
        @include tg-s($w7, usePalette($p-green, $p-700));
    }
    .help-orange {
        display: flex;
        align-items: center;
        @include tg-xs($w7, usePalette($p-red, $p-500));
        &::before {
            content: '  ';
            width: 5px;
            height: 5px;
            border-radius: 100%;
            margin-left: 4px;
            background-color: usePalette($p-red, $p-500);
        }
    }
    .help-info {
        // text
        @include tg-s;
    }
}
</style>
